// extracted by mini-css-extract-plugin
export default {"innerWrapper":"hu-z","tooltipWrapper":"iu-z","icon":"ju-z","tooltip":"ku-z","content":"lu-z"};